/* Sheet panel script: marked links open a dialog; guarded against double loading (D-0527) */
(function () {
  if (window.__drbSheet) return;
  window.__drbSheet = true;

  function toPath(value) {
    if (!value) return null;
    try {
      return new URL(value, window.location.href).pathname.replace(/\/+$/, '');
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('click', function (event) {
    var closer = event.target.closest('[data-drb-sheet-close]');
    if (closer) {
      var owner = closer.closest('dialog');
      if (owner) owner.close();
      return;
    }

    var panel = event.target.closest('[data-drb-sheet]');
    if (panel && event.target === panel) {
      panel.close();
      return;
    }

    var link = event.target.closest('a[href]');
    if (!link) return;

    /* Skip links inside the panel: its own way-out link would reopen it (D-0530) */
    if (link.closest('.drb-sheet')) return;

    var scope = link.closest('[data-drb-sheet-scope]');
    if (!scope) return;

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var target = toPath(link.getAttribute('href'));
    if (!target) return;

    var panels = Array.prototype.slice.call(scope.querySelectorAll('[data-drb-sheet]'));
    var match = null;
    for (var i = 0; i < panels.length; i++) {
      if (toPath(panels[i].getAttribute('data-path')) === target) {
        match = panels[i];
        break;
      }
    }

    /* preventDefault last: any failed check falls back to normal navigation (D-0533) */
    if (!match || typeof match.showModal !== 'function') return;

    event.preventDefault();
    match.showModal();
  });
})();
